// extracted by mini-css-extract-plugin
export default {"story":"Story_story__xVWyf","story__img__wrapper":"Story_story__img__wrapper__TU0DX","story__description":"Story_story__description__ytBlH"};